<template>
  <!-- <v-card class="cvc-card">
    <div v-if="failed" class="pa-4" :style="{height: `${summedHeight}px`}">
      <p>
        <span style="font-weight: 500; font-size: 18px !important">Error loading chart or not enough data.</span>
      </p>
      <p class="font-size-small">
        There has been an error loading this chart.
        <br/>
        Please try refreshing or contact us at
        <a href='mailto:support@covatic.com' class="blue--text">support@covatic.com</a>
        and we can investigate further.
      </p>
    </div>

    <div v-else-if="loading">
      <v-row v-for="(skeletonTypeRow, i) in skeletonTypeMatrix" :key="`skeletons-${i}`" class="mx-3"
        :style="{height: `${skeletonRowHeights[i]}px`}">
        <v-col v-for="(skeletonType, j) in skeletonTypeRow" :key="`skeleton-${i}- ${j}`">
          <v-skeleton-loader v-if="skeletonType"
           :type="skeletonType"
           class="mx-auto"
           :height="skeletonRowHeights[i] - 24"/>
        </v-col>
      </v-row>
    </div>

    <div v-else> -->
    <div>
      <slot/>
    </div>
  <!-- </v-card> -->
</template>

<script>
export default {
  props: {
    failed: {
      type: Boolean,
      required: true
    },
    loading: {
      type: Boolean,
      required: true
    },
    skeletonTypeMatrix: {
      type: Array[Array[String]],
      required: true
    },
    skeletonRowHeights: {
      type: Array[Number],
      required: true
    }
  },
  computed: {
    summedHeight() {
      return this.skeletonRowHeights.reduce((a, b) => a + b)
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "src/styles/_mixins.scss";

  .cvc-card {
    // background-color: #F7F7FC;
    // margin: 0;
    // padding: 40px;
    // height: calc(100vh - 200px);
    // overflow-y: auto;
  }
</style>
